<div class="devIcon" [matMenuTriggerFor]="menu">
  <mat-icon class="dp32">settings</mat-icon>
</div>
<mat-menu #menu>
  <button *ngFor="let item of menuItems" (click)="item.click()" mat-menu-item>{{ item.text }}</button>
</mat-menu>